import React from 'react'
import FeedBackForm from './feedbackForm'
import useToggle from '../hooks/useToggle'

interface CloseWidgetProps {
    config: any
    closeWidget: () => void
    goBack: () => void
    send: (msg: string, payload: string, options?: any) => void
    mainSizing: {
        width: string
        height: string
        menuOverlayHeight: string
    }
}

const CloseWidget: React.FC<CloseWidgetProps> = ({ config, closeWidget, goBack, send, mainSizing }) => {
    const [showFeedbackForm, toggleShowFeedbackForm] = useToggle(false)
    const [backAnimation, toggleBackAnimation] = useToggle(false)

    const { buttons_bg_color, buttons_text_color } = config

    const goBackWithAnimation = () => {
        toggleBackAnimation(true)
        setTimeout(() => {
            goBack()
            toggleBackAnimation(false)
        }, 480)
    }

    const handleGoBack = (submitted: boolean) => {
        if (submitted) {
            closeWidget()
        } else {
            toggleShowFeedbackForm(false)
        }
    }

    const newWidth = mainSizing.width === '50vw' ? 'calc(50vw - 25px)' : `calc(${mainSizing.width} - 15px)`

    return (
        <div className={backAnimation ? 'widgetMenuOverlayfadeOut' : 'widgetMenuOverlay'}>
            <div
                className='widgetMenu closeWidget'
                style={{ width: newWidth, height: `calc(${mainSizing.height} + 25px)`, color: 'black', backgroundColor: 'white' }}
            >
                {showFeedbackForm ? (
                    <FeedBackForm
                        config={config}
                        closeFeedbackForm={handleGoBack}
                        send={send}
                        mainSizing={mainSizing}
                        closeWidget={closeWidget}
                    />
                ) : (
                    <div className='feedbackContainer'>
                        <h3>Before you go</h3>
                        <p>Would you like to give us feedback on your experience?</p>
                        <div className='feedbackButtons'>
                            <button
                                onClick={toggleShowFeedbackForm}
                                style={{ color: buttons_text_color, backgroundColor: buttons_bg_color }}
                            >
                                Give feedback
                            </button>
                            <button
                                onClick={goBackWithAnimation}
                                style={{ color: buttons_text_color, backgroundColor: buttons_bg_color }}
                            >
                                Go Back
                            </button>
                            <button
                                onClick={closeWidget}
                                style={{ color: buttons_text_color, backgroundColor: buttons_bg_color }}
                            >
                                Close Widget
                            </button>
                        </div>
                        <i>Please note: closing the chat will remove your conversation, and it will not be available when you return.</i>
                    </div>
                )}
            </div>
        </div>
    )
}

export default CloseWidget
